const INFO = {
  "Paramètres": [
    ["Paiements", "Stripe — mode TEST (clés côté serveur uniquement)"],
    ["Emails", "Resend via le proxy managé — confirmation, notification admin, contact"],
    ["Webhook Stripe", "/api/stripe/webhook — signature vérifiée"],
    ["Comptes staff", "Gérés par l'administrateur principal (création individuelle)"],
  ],
};

const AdminPlaceholder = ({ title }) => (
  <div data-testid="admin-placeholder" className="space-y-6 max-w-2xl">
    <h1 className="font-display uppercase text-4xl tracking-wide">{title}</h1>
    <div className="bg-noir-surface border border-noir-border p-8">
      {INFO[title] ? (
        <div className="space-y-4">
          {INFO[title].map(([label, value]) => (
            <div key={label} className="flex flex-col sm:flex-row sm:items-baseline justify-between gap-1 py-2.5 border-b border-white/5">
              <span className="text-[10px] uppercase tracking-[0.2em] text-white/40">{label}</span>
              <span className="text-white text-sm">{value}</span>
            </div>
          ))}
          <p className="text-white/35 text-xs pt-2">Les clés et secrets ne sont jamais affichés ici.</p>
        </div>
      ) : (
        <p className="text-white/50 text-sm">
          Cette section sera disponible dans une prochaine phase. Aucune donnée fictive n'est affichée ici.
        </p>
      )}
    </div>
  </div>
);

export default AdminPlaceholder;
